import React, { useEffect, useState } from "react";
import OrderSummary from "../OrderSummary";
import WhiteTitledCard from "../../../../components/cards/WhiteTitledCard";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import OrdersInTransitTable from "./OrdersInTransitTable";
import { RootState } from "../../../../redux/app/store";
import Dropdown from "../../../ui/SelectDropdown";
import {
  mapDataToLabelValue,
  canPickCourierOfficeOnDispatch,
} from "../../../../helpers";
import Button from "../../../ui/Button";
import { fetchCourierOffice } from "../../../../redux/features/CourrierSlice";

const OrdersInTransit = () => {
  const { ordersInTransit } = useAppSelector((state) => state.orders);
  const { user } = useAppSelector((state) => state.auth);
  const [courierOfficeId, setCourierOfficeId] = useState<string>();
  const [confirmBulkTransit, setConfirmBulkTransit] = useState<boolean>(false);
  const { courierOffices } = useAppSelector(
    (state: RootState) => state.courier
  );
  const dispatch = useAppDispatch();

  const tabList = [
    {
      id: 1,
      name: "Orders In Transit",
      count: ordersInTransit?.totalItems ?? 0,
    },
  ];

  useEffect(() => {
    dispatch(fetchCourierOffice({}));
  }, [dispatch]);

  return (
    <div className=" flex flex-col gap-6 p-4  sm:p-6 md:p-8 bg-gray-100 min-h-screen">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold mb-4">Order Management</h1>
      </div>
      <OrderSummary />
      <WhiteTitledCard>
        <div className="px-6">
          <div className="flex  items-center justify-between">
            {tabList?.map((tab) => (
              <div
                key={tab.id}
                className={`space-x-2 cursor-pointer text-sm font-semibold p-2
                text-black border-b-2 border-primary
                   `}
              >
                <span>{tab.name}</span>
                {
                  <span
                    className={"bg-lightPurple px-2  text-accent rounded-md"}
                  >
                    {/* {tab?.count} */}
                  </span>
                }
              </div>
            ))}

            <div className="flex gap-2 items-center">
              {canPickCourierOfficeOnDispatch(user) && (
                <Dropdown
                  options={mapDataToLabelValue(
                    courierOffices?.data?.data,
                    "name",
                    "id"
                  )}
                  onSelect={(value) => setCourierOfficeId(value)}
                  placeholder="Select Office"
                />
              )}
              <Button
                layout="toolbar" size="sm"
                label="Initiate Bulk Transit"
                onClick={() => setConfirmBulkTransit(true)}
                classNames="hidden sm:flex min-w-[200px]"
              />
            </div>
          </div>
        </div>
        <OrdersInTransitTable
          courierOfficeId={user?.user?.adminCourierOfficeId ?? courierOfficeId}
          cancelBulkModal={() => setConfirmBulkTransit(false)}
          openBulkModal={confirmBulkTransit}
          agentId={user?.user?.id}
        />
      </WhiteTitledCard>
    </div>
  );
};

export default OrdersInTransit;
